import { render } from "./AppTypeahead.vue?vue&type=template&id=f73140a4"
import script from "./AppTypeahead.vue?vue&type=script&lang=js"
export * from "./AppTypeahead.vue?vue&type=script&lang=js"

import "./AppTypeahead.vue?vue&type=style&index=0&id=f73140a4&lang=css"

import exportComponent from "C:\\GIT CLONADO\\ubiku.2023\\com.ubiku.ges.ios\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__